/**
 * @description 判斷單號類別為 網要、網投用
*/
export enum ApplyNoType {
    /** 網投 */
    WebInsured = 'P',
    /** 網要 */
    WebRequire = 'A'
}
